import React from "react";
import { Cpu, Brain, Globe, Users } from "lucide-react";

const items = [
  {
    icon: Cpu,
    title: "ATS propio con IA",
    desc: "No depende de software de terceros, el sistema aprende con cada proceso suyo.",
  },
  {
    icon: Brain,
    title: "Psicometría integrada",
    desc: "Envíe evaluaciones directamente desde el ATS, sin plataformas externas.",
  },
  {
    icon: Globe,
    title: "+17 job boards en un clic",
    desc: "Publique en Indeed, LinkedIn, ZipRecruiter y más desde una sola pantalla.",
  },
  {
    icon: Users,
    title: "Servicio de reclutamiento disponible",
    desc: "Si necesita un equipo especializado para cubrir una vacante, también lo tenemos.",
  },
];

const WhyNexus: React.FC = () => {
  return (
    <section id="por-que-nexus" style={{ background: "#F8F7FF", paddingTop: "80px", paddingBottom: "80px" }}>
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <h2
            className="font-exo font-bold mb-4"
            style={{ fontSize: "clamp(2rem, 4vw, 3rem)", color: "#1A1A2E" }}
          >
            Más que un ATS. Un ecosistema completo.
          </h2>
          <p className="text-base text-muted-foreground">
            Tecnología, psicometría y talento humano especializado, integrados en un solo lugar.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((it) => (
            <div
              key={it.title}
              className="bg-white rounded-2xl p-6 border hover:shadow-xl transition-all"
              style={{ borderColor: "rgba(98, 10, 226, 0.1)" }}
            >
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center mb-4"
                style={{ background: "linear-gradient(135deg, #620AE2, #00C9D4)" }}
              >
                <it.icon className="h-6 w-6 text-white" />
              </div>
              <h3 className="font-bold text-base mb-2" style={{ color: "#1A1A2E" }}>
                {it.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{it.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyNexus;
